/**
 * Container Component
 * Centered content container with max-width
 */

import React, { forwardRef } from 'react';
import { Box } from '../primitives/Box';

/**
 * Container Component
 * 
 * @example
 * <Container maxW="container.lg">
 *   Centered content
 * </Container>
 */
export const Container = forwardRef(({
  centerContent = false,
  ...props
}, ref) => {
  return (
    <Box
      ref={ref}
      w="100%"
      maxW="container.lg"
      mx="auto"
      px={4}
      {...(centerContent && {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      })}
      {...props}
    />
  );
});

Container.displayName = 'Container';

export default Container;
